import React from "react";
import styled from "styled-components";

const YMMTFormWrapper = styled.div``;

const YMMTFormContainer = ({ children }) => (
  <YMMTFormWrapper>{children}</YMMTFormWrapper>
);

export default YMMTFormContainer;
